import React, { useState } from "react";

const Nadawe = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  const products = [
    { 
      id: 81, 
      img: "https://i.postimg.cc/NFy12NKb/55.png",
      caption: " الابتزاز الألكتروني"
    },
    { 
      id: 82, 
      img: "https://i.postimg.cc/DZ0GRCPF/00.png",
      caption: "ندوة عن التنمر"
    },
     { 
      id: 82, 
      img: "https://i.postimg.cc/mrDDKCZG/image.png",
      caption: "ندوة اسلوب المعلم الناجح "
    },
     { 
      id: 82, 
      img: "https://i.postimg.cc/fTrgxh3j/0.png",
      caption: "ندوة التوحد وصعوبات التعليم"
    },
  ];

  return (
    <section className="shop">
      <h1 className="section-title"> ندوات</h1>
      <div className="product-list">
        {products.map((product) => {
          const whatsappMessage = `مرحبا هل يمكني انا استفسر عن الدوراث  (${product.caption}).`;
          const whatsappLink = `https://wa.me/70163001?text=${encodeURIComponent(whatsappMessage)}`;

          return (
            <div key={product.id} className="product-box">
              <div className="img-box">
                <img 
                  src={product.img} 
                  alt={product.caption} 
                  onClick={() => setSelectedImg(product.img)} 
                />
              </div>

              {/* الكابشن */}
              <p className="product-caption">{product.caption}</p>
               <br/>
              <a 
                href={whatsappLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="whatsapp-card"
              >
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
                  alt="WhatsApp" 
                  width="25" 
                  height="25" 
                />
                <span>التواصل عبر الواتس اب</span>
              </a>
            </div>
          );
        })}
      </div>

      {/* نافذة تكبير الصورة */}
      {selectedImg && (
        <div className="popup" onClick={() => setSelectedImg(null)}>
          <span className="close">&times;</span>
          <img src={selectedImg} alt="Zoomed" className="popup-img" />
        </div>
      )}
    </section>
  );
};

export default Nadawe;
